module.exports = __webpack_public_path__ + "img/GAME_OMOK2.2b13be02.jpg";